const ID_SEGMENT = /^(?:[0-9a-f]{24}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|\d+|(?=[A-Za-z_-]*\d)[A-Za-z0-9_-]{16,})$/i;

/**
 * A backoffice path as a page, never with an id in it:
 * `/vendors/66f0…/edit` → `/vendors/:id/edit`. The query string is dropped
 * (it can hold searches); only the `tab` is kept, apart.
 */
export function pageOf(pathname: string): string {
  const segments = String(pathname || '/').split('?')[0].split('#')[0].split('/').filter(Boolean);
  const clean = segments.map((s) => (ID_SEGMENT.test(s) ? ':id' : s.replace(/[^\w\-.]/g, '').slice(0, 40)));
  return `/${clean.join('/')}`.slice(0, 150) || '/';
}
